import React from 'react';
import PropTypes from 'prop-types';

export default function CreateListingSuccess({ listing }) {
  return <React.Fragment>
    <p>
      A <b>draft</b> listing {listing.label ? `for ${listing.label}` : ''} has been created.
    </p>

    <p>
      The listing status is <b>{listing.statusLabel}</b>.
      To update, fill out all required fields and save the listing.
    </p>
  </React.Fragment>;
}

CreateListingSuccess.propTypes = {
  listing: PropTypes.shape({
    label: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
  }).isRequired,
};
